export default "__VITE_ASSET__BwzCEp8e__"